import React from 'react'

export const SpinningProfiles = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid meet"
      width="300"
      height="190"
      viewBox="0 0 300 190"
    >
      <defs>
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_3_G"
          fill="freeze"
          keyTimes="0;0.7;0.9;1"
          path="M150 -104 C150,-104 150,-104 150,-104 C150,-70.75 150,62.25 150,95.5 C150,95.5 150,95.5 150,95.5 "
          keyPoints="0;0;1;1"
          keySplines="0.09 0.145 0 0.995;0.09 0.145 0 0.995;0.333 0.333 0.667 0.667"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_3_G"
          fill="freeze"
          attributeName="transform"
          from="0.7000000000000001 0.7000000000000001"
          to="0.7000000000000001 0.7000000000000001"
          type="scale"
          additive="sum"
          keyTimes="0;1"
          values="0.7000000000000001 0.7000000000000001;0.7000000000000001 0.7000000000000001"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_3_G"
          fill="freeze"
          attributeName="transform"
          from="-179.5 -131"
          to="-179.5 -131"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-179.5 -131;-179.5 -131"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_3_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="1"
          keyTimes="0;0.7;0.7000004;1"
          values="0;0;1;1"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_2_G"
          fill="freeze"
          keyTimes="0;0.4;0.6;0.7;0.9;1"
          path="M150 -104 C150,-104 150,-104 150,-104 C150,-70.75 150,62.25 150,95.5 C150,95.5 150,95.5 150,95.5 C150,128.75 150,261.75 150,295 C150,295 150,295 150,295 "
          keyPoints="0;0;0.5;0.5;1;1"
          keySplines="0.09 0.145 0 0.995;0.09 0.145 0 0.995;0.333 0.333 0.667 0.667;0.081 0.123 0 0.965;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_2_G"
          fill="freeze"
          attributeName="transform"
          from="0.7000000000000001 0.7000000000000001"
          to="0.7000000000000001 0.7000000000000001"
          type="scale"
          additive="sum"
          keyTimes="0;1"
          values="0.7000000000000001 0.7000000000000001;0.7000000000000001 0.7000000000000001"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_2_G"
          fill="freeze"
          attributeName="transform"
          from="-179.5 -131"
          to="-179.5 -131"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-179.5 -131;-179.5 -131"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_2_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.4;0.4000004;0.9;0.9;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_1_G"
          fill="freeze"
          keyTimes="0;0.1;0.3;0.4;0.6;1"
          path="M150 -104 C150,-104 150,-104 150,-104 C150,-70.75 150,62.25 150,95.5 C150,95.5 150,95.5 150,95.5 C150,128.75 150,261.75 150,295 C150,295 150,295 150,295 "
          keyPoints="0;0;0.5;0.5;1;1"
          keySplines="0.09 0.145 0 0.995;0.09 0.145 0 0.995;0.333 0.333 0.667 0.667;0.081 0.123 0 0.965;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_1_G"
          fill="freeze"
          attributeName="transform"
          from="0.7000000000000001 0.7000000000000001"
          to="0.7000000000000001 0.7000000000000001"
          type="scale"
          additive="sum"
          keyTimes="0;1"
          values="0.7000000000000001 0.7000000000000001;0.7000000000000001 0.7000000000000001"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_1_G"
          fill="freeze"
          attributeName="transform"
          from="-179.5 -131"
          to="-179.5 -131"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-179.5 -131;-179.5 -131"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_1_G_M"
          fill="freeze"
          attributeName="opacity"
          from="0"
          to="0"
          keyTimes="0;0.1;0.1000004;0.6;0.6;1"
          values="0;0;1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_0_G"
          fill="freeze"
          keyTimes="0;0.1;0.3;1"
          path="M150 95.5 C150,95.5 150,95.5 150,95.5 C150,128.75 150,261.75 150,295 C150,295 150,295 150,295 "
          keyPoints="0;0;1;1"
          keySplines="0.333 0.333 0.667 0.667;0.081 0.123 0 0.965;0 0 0 0"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="0.7000000000000001 0.7000000000000001"
          to="0.7000000000000001 0.7000000000000001"
          type="scale"
          additive="sum"
          keyTimes="0;1"
          values="0.7000000000000001 0.7000000000000001;0.7000000000000001 0.7000000000000001"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="-179.5 -131"
          to="-179.5 -131"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-179.5 -131;-179.5 -131"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_1_G_L_0_G_M"
          fill="freeze"
          attributeName="opacity"
          from="1"
          to="0"
          keyTimes="0;0.3;0.3;1"
          values="1;1;0;0"
          keySplines="0 0 0 0;0 0 0 0;0 0 0 0"
          calcMode="spline"
        />
        <animateMotion
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          keyTimes="0;0.1;0.3;0.4;0.6;0.7;0.9;1"
          path="M49.5 143.5 C49.5,143.5 49.5,143.5 49.5,143.5 C83.5,143.67 253.5,144.5 253.5,144.5 C253.5,144.5 253.5,144.5 253.5,144.5 C253.5,144.5 254,51 254,51 C254,51 254,51 254,51 C254,51 83.58,128.08 49.5,143.5 C49.5,143.5 49.5,143.5 49.5,143.5 "
          keyPoints="0;0;0.39;0.39;0.57;0.57;1;1"
          keySplines="0.233 0.233 0.833 0.833;0.233 0.278 0.833 1;0.019 0.019 0.833 0.833;0.019 0.049 0.833 1;0.019 0.019 0.833 0.833;0.019 0.02 0.833 0.833;0.233 0.233 0.833 0.833"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="45"
          to="45"
          type="rotate"
          additive="sum"
          keyTimes="0;0.1;0.3;0.4;0.6;0.7;0.9;1"
          values="45;45;-46;-46;-52;-52;45;45"
          keySplines="0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833;0.167 0.167 0.833 0.833"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="0.43 0.43"
          to="0.43 0.43"
          type="scale"
          additive="sum"
          keyTimes="0;1"
          values="0.43 0.43;0.43 0.43"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animateTransform
          repeatCount="indefinite"
          dur="10s"
          begin="0s"
          xlinkHref="#_R_G_L_0_G"
          fill="freeze"
          attributeName="transform"
          from="-54 -104"
          to="-54 -104"
          type="translate"
          additive="sum"
          keyTimes="0;1"
          values="-54 -104;-54 -104"
          keySplines="0 0 1 1"
          calcMode="spline"
        />
        <animate attributeType="XML" attributeName="opacity" dur="10s" from="0" to="1" xlinkHref="#time_group" />
      </defs>
      <g id="_R_G">
        <g id="_R_G_L_1_G">
          <g id="_R_G_L_1_G_L_3_G_M">
            <g id="_R_G_L_1_G_L_3_G">
              <path
                id="_R_G_L_1_G_L_3_G_D_0_P_0"
                fill="#ffffff"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M345.03 253.6 C345.03,253.6 13.97,253.6 13.97,253.6 C10.74,253.6 8.13,250.98 8.13,247.76 C8.13,247.76 8.13,14.24 8.13,14.24 C8.13,11.02 10.74,8.4 13.97,8.4 C13.97,8.4 345.03,8.4 345.03,8.4 C348.25,8.4 350.87,11.02 350.87,14.24 C350.87,14.24 350.87,247.76 350.87,247.76 C350.87,250.98 348.25,253.6 345.03,253.6z "
              />
              <path
                id="_R_G_L_1_G_L_3_G_D_1_P_0"
                className="stroke-primary"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
                strokeWidth="1"
                strokeOpacity="1"
                d=" M345.03 253.6 C345.03,253.6 13.97,253.6 13.97,253.6 C10.74,253.6 8.13,250.98 8.13,247.76 C8.13,247.76 8.13,14.24 8.13,14.24 C8.13,11.02 10.74,8.4 13.97,8.4 C13.97,8.4 345.03,8.4 345.03,8.4 C348.25,8.4 350.87,11.02 350.87,14.24 C350.87,14.24 350.87,247.76 350.87,247.76 C350.87,250.98 348.25,253.6 345.03,253.6z "
              />
              <path
                id="_R_G_L_1_G_L_3_G_D_2_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M179.5 21.5 C206.01,21.5 227.5,42.99 227.5,69.5 C227.5,96.01 206.01,117.5 179.5,117.5 C152.99,117.5 131.5,96.01 131.5,69.5 C131.5,42.99 152.99,21.5 179.5,21.5z "
              />
              <path
                id="_R_G_L_1_G_L_3_G_D_3_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M143.88 101.68 C152.67,111.39 165.37,117.5 179.5,117.5 C193.63,117.5 206.33,111.39 215.12,101.68 C211.34,91.41 203.25,83.24 193.05,79.33 C198.19,75.31 201.5,69.05 201.5,62.01 C201.5,49.86 191.65,40.01 179.5,40.01 C167.35,40.01 157.5,49.86 157.5,62.01 C157.5,69.05 160.81,75.31 165.95,79.33 C155.75,83.24 147.66,91.41 143.88,101.68z "
              />
              <path
                id="_R_G_L_1_G_L_3_G_D_4_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M126.5 130.5 C126.5,130.5 232.5,130.5 232.5,130.5 C234.16,130.5 235.5,131.84 235.5,133.5 C235.5,133.5 235.5,147.5 235.5,147.5 C235.5,149.16 234.16,150.5 232.5,150.5 C232.5,150.5 126.5,150.5 126.5,150.5 C124.84,150.5 123.5,149.16 123.5,147.5 C123.5,147.5 123.5,133.5 123.5,133.5 C123.5,131.84 124.84,130.5 126.5,130.5z "
              />
              <path
                id="_R_G_L_1_G_L_3_G_D_5_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M51 163.5 C51,163.5 173,163.5 173,163.5 C181.84,163.5 189,170.66 189,179.5 C189,188.34 181.84,195.5 173,195.5 C173,195.5 51,195.5 51,195.5 C42.16,195.5 35,188.34 35,179.5 C35,170.66 42.16,163.5 51,163.5z "
              />
              <path
                id="_R_G_L_1_G_L_3_G_D_6_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M230 163.5 C230,163.5 308,163.5 308,163.5 C316.84,163.5 324,170.66 324,179.5 C324,188.34 316.84,195.5 308,195.5 C308,195.5 230,195.5 230,195.5 C221.16,195.5 214,188.34 214,179.5 C214,170.66 221.16,163.5 230,163.5z "
              />
              <path
                id="_R_G_L_1_G_L_3_G_D_7_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M51 208.5 C51,208.5 118,208.5 118,208.5 C126.84,208.5 134,215.66 134,224.5 C134,233.34 126.84,240.5 118,240.5 C118,240.5 51,240.5 51,240.5 C42.16,240.5 35,233.34 35,224.5 C35,215.66 42.16,208.5 51,208.5z "
              />
              <path
                id="_R_G_L_1_G_L_3_G_D_8_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M175 208.5 C175,208.5 308,208.5 308,208.5 C316.84,208.5 324,215.66 324,224.5 C324,233.34 316.84,240.5 308,240.5 C308,240.5 175,240.5 175,240.5 C166.16,240.5 159,233.34 159,224.5 C159,215.66 166.16,208.5 175,208.5z "
              />
            </g>
          </g>
          <g id="_R_G_L_1_G_L_2_G_M">
            <g id="_R_G_L_1_G_L_2_G">
              <path
                id="_R_G_L_1_G_L_2_G_D_0_P_0"
                fill="#ffffff"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M345.03 253.6 C345.03,253.6 13.97,253.6 13.97,253.6 C10.74,253.6 8.13,250.98 8.13,247.76 C8.13,247.76 8.13,14.24 8.13,14.24 C8.13,11.02 10.74,8.4 13.97,8.4 C13.97,8.4 345.03,8.4 345.03,8.4 C348.25,8.4 350.87,11.02 350.87,14.24 C350.87,14.24 350.87,247.76 350.87,247.76 C350.87,250.98 348.25,253.6 345.03,253.6z "
              />
              <path
                id="_R_G_L_1_G_L_2_G_D_1_P_0"
                className="stroke-primary"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
                strokeWidth="1"
                strokeOpacity="1"
                d=" M345.03 253.6 C345.03,253.6 13.97,253.6 13.97,253.6 C10.74,253.6 8.13,250.98 8.13,247.76 C8.13,247.76 8.13,14.24 8.13,14.24 C8.13,11.02 10.74,8.4 13.97,8.4 C13.97,8.4 345.03,8.4 345.03,8.4 C348.25,8.4 350.87,11.02 350.87,14.24 C350.87,14.24 350.87,247.76 350.87,247.76 C350.87,250.98 348.25,253.6 345.03,253.6z "
              />
              <path
                id="_R_G_L_1_G_L_2_G_D_2_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M179.5 21.5 C206.01,21.5 227.5,42.99 227.5,69.5 C227.5,96.01 206.01,117.5 179.5,117.5 C152.99,117.5 131.5,96.01 131.5,69.5 C131.5,42.99 152.99,21.5 179.5,21.5z "
              />
              <path
                id="_R_G_L_1_G_L_2_G_D_3_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M143.88 101.68 C152.67,111.39 165.37,117.5 179.5,117.5 C193.63,117.5 206.33,111.39 215.12,101.68 C211.34,91.41 203.25,83.24 193.05,79.33 C198.19,75.31 201.5,69.05 201.5,62.01 C201.5,49.86 191.65,40.01 179.5,40.01 C167.35,40.01 157.5,49.86 157.5,62.01 C157.5,69.05 160.81,75.31 165.95,79.33 C155.75,83.24 147.66,91.41 143.88,101.68z "
              />
              <path
                id="_R_G_L_1_G_L_2_G_D_4_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M126.5 130.5 C126.5,130.5 232.5,130.5 232.5,130.5 C234.16,130.5 235.5,131.84 235.5,133.5 C235.5,133.5 235.5,147.5 235.5,147.5 C235.5,149.16 234.16,150.5 232.5,150.5 C232.5,150.5 126.5,150.5 126.5,150.5 C124.84,150.5 123.5,149.16 123.5,147.5 C123.5,147.5 123.5,133.5 123.5,133.5 C123.5,131.84 124.84,130.5 126.5,130.5z "
              />
              <path
                id="_R_G_L_1_G_L_2_G_D_5_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M51 163.5 C51,163.5 173,163.5 173,163.5 C181.84,163.5 189,170.66 189,179.5 C189,188.34 181.84,195.5 173,195.5 C173,195.5 51,195.5 51,195.5 C42.16,195.5 35,188.34 35,179.5 C35,170.66 42.16,163.5 51,163.5z "
              />
              <path
                id="_R_G_L_1_G_L_2_G_D_6_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M230 163.5 C230,163.5 308,163.5 308,163.5 C316.84,163.5 324,170.66 324,179.5 C324,188.34 316.84,195.5 308,195.5 C308,195.5 230,195.5 230,195.5 C221.16,195.5 214,188.34 214,179.5 C214,170.66 221.16,163.5 230,163.5z "
              />
              <path
                id="_R_G_L_1_G_L_2_G_D_7_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M51 208.5 C51,208.5 118,208.5 118,208.5 C126.84,208.5 134,215.66 134,224.5 C134,233.34 126.84,240.5 118,240.5 C118,240.5 51,240.5 51,240.5 C42.16,240.5 35,233.34 35,224.5 C35,215.66 42.16,208.5 51,208.5z "
              />
              <path
                id="_R_G_L_1_G_L_2_G_D_8_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M175 208.5 C175,208.5 308,208.5 308,208.5 C316.84,208.5 324,215.66 324,224.5 C324,233.34 316.84,240.5 308,240.5 C308,240.5 175,240.5 175,240.5 C166.16,240.5 159,233.34 159,224.5 C159,215.66 166.16,208.5 175,208.5z "
              />
            </g>
          </g>
          <g id="_R_G_L_1_G_L_1_G_M">
            <g id="_R_G_L_1_G_L_1_G">
              <path
                id="_R_G_L_1_G_L_1_G_D_0_P_0"
                fill="#ffffff"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M345.03 253.6 C345.03,253.6 13.97,253.6 13.97,253.6 C10.74,253.6 8.13,250.98 8.13,247.76 C8.13,247.76 8.13,14.24 8.13,14.24 C8.13,11.02 10.74,8.4 13.97,8.4 C13.97,8.4 345.03,8.4 345.03,8.4 C348.25,8.4 350.87,11.02 350.87,14.24 C350.87,14.24 350.87,247.76 350.87,247.76 C350.87,250.98 348.25,253.6 345.03,253.6z "
              />
              <path
                id="_R_G_L_1_G_L_1_G_D_1_P_0"
                className="stroke-primary"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
                strokeWidth="1"
                strokeOpacity="1"
                d=" M345.03 253.6 C345.03,253.6 13.97,253.6 13.97,253.6 C10.74,253.6 8.13,250.98 8.13,247.76 C8.13,247.76 8.13,14.24 8.13,14.24 C8.13,11.02 10.74,8.4 13.97,8.4 C13.97,8.4 345.03,8.4 345.03,8.4 C348.25,8.4 350.87,11.02 350.87,14.24 C350.87,14.24 350.87,247.76 350.87,247.76 C350.87,250.98 348.25,253.6 345.03,253.6z "
              />
              <path
                id="_R_G_L_1_G_L_1_G_D_2_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M179.5 21.5 C206.01,21.5 227.5,42.99 227.5,69.5 C227.5,96.01 206.01,117.5 179.5,117.5 C152.99,117.5 131.5,96.01 131.5,69.5 C131.5,42.99 152.99,21.5 179.5,21.5z "
              />
              <path
                id="_R_G_L_1_G_L_1_G_D_3_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M143.88 101.68 C152.67,111.39 165.37,117.5 179.5,117.5 C193.63,117.5 206.33,111.39 215.12,101.68 C211.34,91.41 203.25,83.24 193.05,79.33 C198.19,75.31 201.5,69.05 201.5,62.01 C201.5,49.86 191.65,40.01 179.5,40.01 C167.35,40.01 157.5,49.86 157.5,62.01 C157.5,69.05 160.81,75.31 165.95,79.33 C155.75,83.24 147.66,91.41 143.88,101.68z "
              />
              <path
                id="_R_G_L_1_G_L_1_G_D_4_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M126.5 130.5 C126.5,130.5 232.5,130.5 232.5,130.5 C234.16,130.5 235.5,131.84 235.5,133.5 C235.5,133.5 235.5,147.5 235.5,147.5 C235.5,149.16 234.16,150.5 232.5,150.5 C232.5,150.5 126.5,150.5 126.5,150.5 C124.84,150.5 123.5,149.16 123.5,147.5 C123.5,147.5 123.5,133.5 123.5,133.5 C123.5,131.84 124.84,130.5 126.5,130.5z "
              />
              <path
                id="_R_G_L_1_G_L_1_G_D_5_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M51 163.5 C51,163.5 173,163.5 173,163.5 C181.84,163.5 189,170.66 189,179.5 C189,188.34 181.84,195.5 173,195.5 C173,195.5 51,195.5 51,195.5 C42.16,195.5 35,188.34 35,179.5 C35,170.66 42.16,163.5 51,163.5z "
              />
              <path
                id="_R_G_L_1_G_L_1_G_D_6_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M230 163.5 C230,163.5 308,163.5 308,163.5 C316.84,163.5 324,170.66 324,179.5 C324,188.34 316.84,195.5 308,195.5 C308,195.5 230,195.5 230,195.5 C221.16,195.5 214,188.34 214,179.5 C214,170.66 221.16,163.5 230,163.5z "
              />
              <path
                id="_R_G_L_1_G_L_1_G_D_7_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M51 208.5 C51,208.5 118,208.5 118,208.5 C126.84,208.5 134,215.66 134,224.5 C134,233.34 126.84,240.5 118,240.5 C118,240.5 51,240.5 51,240.5 C42.16,240.5 35,233.34 35,224.5 C35,215.66 42.16,208.5 51,208.5z "
              />
              <path
                id="_R_G_L_1_G_L_1_G_D_8_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M175 208.5 C175,208.5 308,208.5 308,208.5 C316.84,208.5 324,215.66 324,224.5 C324,233.34 316.84,240.5 308,240.5 C308,240.5 175,240.5 175,240.5 C166.16,240.5 159,233.34 159,224.5 C159,215.66 166.16,208.5 175,208.5z "
              />
            </g>
          </g>
          <g id="_R_G_L_1_G_L_0_G_M">
            <g id="_R_G_L_1_G_L_0_G">
              <path
                id="_R_G_L_1_G_L_0_G_D_0_P_0"
                fill="#ffffff"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M345.03 253.6 C345.03,253.6 13.97,253.6 13.97,253.6 C10.74,253.6 8.13,250.98 8.13,247.76 C8.13,247.76 8.13,14.24 8.13,14.24 C8.13,11.02 10.74,8.4 13.97,8.4 C13.97,8.4 345.03,8.4 345.03,8.4 C348.25,8.4 350.87,11.02 350.87,14.24 C350.87,14.24 350.87,247.76 350.87,247.76 C350.87,250.98 348.25,253.6 345.03,253.6z "
              />
              <path
                id="_R_G_L_1_G_L_0_G_D_1_P_0"
                className="stroke-primary"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
                strokeWidth="1"
                strokeOpacity="1"
                d=" M345.03 253.6 C345.03,253.6 13.97,253.6 13.97,253.6 C10.74,253.6 8.13,250.98 8.13,247.76 C8.13,247.76 8.13,14.24 8.13,14.24 C8.13,11.02 10.74,8.4 13.97,8.4 C13.97,8.4 345.03,8.4 345.03,8.4 C348.25,8.4 350.87,11.02 350.87,14.24 C350.87,14.24 350.87,247.76 350.87,247.76 C350.87,250.98 348.25,253.6 345.03,253.6z "
              />
              <path
                id="_R_G_L_1_G_L_0_G_D_2_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M179.5 21.5 C206.01,21.5 227.5,42.99 227.5,69.5 C227.5,96.01 206.01,117.5 179.5,117.5 C152.99,117.5 131.5,96.01 131.5,69.5 C131.5,42.99 152.99,21.5 179.5,21.5z "
              />
              <path
                id="_R_G_L_1_G_L_0_G_D_3_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M143.88 101.68 C152.67,111.39 165.37,117.5 179.5,117.5 C193.63,117.5 206.33,111.39 215.12,101.68 C211.34,91.41 203.25,83.24 193.05,79.33 C198.19,75.31 201.5,69.05 201.5,62.01 C201.5,49.86 191.65,40.01 179.5,40.01 C167.35,40.01 157.5,49.86 157.5,62.01 C157.5,69.05 160.81,75.31 165.95,79.33 C155.75,83.24 147.66,91.41 143.88,101.68z "
              />
              <path
                id="_R_G_L_1_G_L_0_G_D_4_P_0"
                className="fill-primary"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M126.5 130.5 C126.5,130.5 232.5,130.5 232.5,130.5 C234.16,130.5 235.5,131.84 235.5,133.5 C235.5,133.5 235.5,147.5 235.5,147.5 C235.5,149.16 234.16,150.5 232.5,150.5 C232.5,150.5 126.5,150.5 126.5,150.5 C124.84,150.5 123.5,149.16 123.5,147.5 C123.5,147.5 123.5,133.5 123.5,133.5 C123.5,131.84 124.84,130.5 126.5,130.5z "
              />
              <path
                id="_R_G_L_1_G_L_0_G_D_5_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M51 163.5 C51,163.5 173,163.5 173,163.5 C181.84,163.5 189,170.66 189,179.5 C189,188.34 181.84,195.5 173,195.5 C173,195.5 51,195.5 51,195.5 C42.16,195.5 35,188.34 35,179.5 C35,170.66 42.16,163.5 51,163.5z "
              />
              <path
                id="_R_G_L_1_G_L_0_G_D_6_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M230 163.5 C230,163.5 308,163.5 308,163.5 C316.84,163.5 324,170.66 324,179.5 C324,188.34 316.84,195.5 308,195.5 C308,195.5 230,195.5 230,195.5 C221.16,195.5 214,188.34 214,179.5 C214,170.66 221.16,163.5 230,163.5z "
              />
              <path
                id="_R_G_L_1_G_L_0_G_D_7_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M51 208.5 C51,208.5 118,208.5 118,208.5 C126.84,208.5 134,215.66 134,224.5 C134,233.34 126.84,240.5 118,240.5 C118,240.5 51,240.5 51,240.5 C42.16,240.5 35,233.34 35,224.5 C35,215.66 42.16,208.5 51,208.5z "
              />
              <path
                id="_R_G_L_1_G_L_0_G_D_8_P_0"
                className="fill-primary-light"
                fillOpacity="1"
                fillRule="nonzero"
                d=" M175 208.5 C175,208.5 308,208.5 308,208.5 C316.84,208.5 324,215.66 324,224.5 C324,233.34 316.84,240.5 308,240.5 C308,240.5 175,240.5 175,240.5 C166.16,240.5 159,233.34 159,224.5 C159,215.66 166.16,208.5 175,208.5z "
              />
            </g>
          </g>
        </g>
        <g id="_R_G_L_0_G">
          <path
            id="_R_G_L_0_G_D_0_P_0"
            fill="#ffffff"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M28.39 19.05 C47.72,4.91 74.85,9.11 88.99,28.44 C103.14,47.77 98.93,74.9 79.61,89.04 C60.28,103.18 33.15,98.98 19.01,79.65 C4.87,60.33 9.07,33.2 28.39,19.05z "
          />
          <path
            id="_R_G_L_0_G_D_1_P_0"
            stroke="#757575"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
            strokeWidth="12"
            strokeOpacity="1"
            d=" M53.92 7.08 C80.27,7.04 101.67,28.36 101.71,54.71 C101.76,81.07 80.43,102.46 54.08,102.51 C27.73,102.55 6.33,81.23 6.29,54.88 C6.24,28.53 27.57,7.13 53.92,7.08z "
          />
          <path
            id="_R_G_L_0_G_D_2_P_0"
            fill="#757575"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M45.41 105.72 C45.41,105.72 62.41,105.69 62.41,105.69 C62.41,105.69 62.59,177.98 62.59,177.98 C62.59,177.98 45.59,179.37 45.59,179.37 C45.59,179.37 45.41,105.72 45.41,105.72z "
          />
          <path
            id="_R_G_L_0_G_D_3_P_0"
            fill="#757575"
            fillOpacity="1"
            fillRule="nonzero"
            d=" M42.45 120.69 C42.45,120.69 65.41,120.65 65.41,120.65 C67.06,120.65 68.41,121.99 68.41,123.65 C68.41,123.65 68.55,196.73 68.55,196.73 C68.55,198.38 67.21,199.73 65.55,199.73 C65.55,199.73 42.59,199.77 42.59,199.77 C40.94,199.77 39.59,198.43 39.59,196.77 C39.59,196.77 39.46,123.69 39.46,123.69 C39.45,122.04 40.79,120.69 42.45,120.69z "
          />
        </g>
      </g>
      <g id="time_group" />
    </svg>
  )
}
